import React from "react";
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function Hero() {
  const { t } = useTranslation();

  const slides = [
    {
      id: 1,
      image: "assets/images/homepage/home_1_slider_2.jpg",
      title: t('hero.title'),
      highlight: t('hero.highlight'),
      subtitle: t('hero.subtitle'),
      description: t('hero.description'),
    },
    {
      id: 2,
      image: "assets/images/homepage/home_1_slider_1.jpg",
      title: t('hero.title'),
      highlight: t('hero.highlight'),
      subtitle: t('hero.subtitle'),
      description: t('hero.description'),
    },
  ];
  return (
    <div className="relative w-full">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000 }}
        loop
        className="w-full h-[500px]"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="h-full bg-center bg-cover bg-no-repeat flex items-center justify-center text-white"
              style={{
                backgroundImage: `linear-gradient(rgba(17,17,17,0.4), rgba(17,17,17,0.4)), url(${slide.image})`,
              }}
            >
              <div className="text-center max-w-2xl px-4">
                <h2 className="text-3xl md:text-5xl font-bold uppercase mb-4 text-white">
                  {slide.title} <br />
                  <span className="text-yellow-400">{slide.highlight}</span> {slide.subtitle}
                </h2>
                <h3 className="text-lg md:text-xl mb-6 text-white">{slide.description}</h3>
                <a
                  href="#"
                  className="inline-block bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-4 px-6 rounded-[100px] transition"
                >
                  {t('hero.cta')}
                </a>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
